import { render, staticRenderFns } from "./OrganizationContacts.vue?vue&type=template&id=db8dc27c&"
import script from "./OrganizationContacts.vue?vue&type=script&lang=js&"
export * from "./OrganizationContacts.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports